import { useTranslation } from "react-i18next";
import {
  Box,
  FormElementWrapper,
  LabelStyled,
  SpanStyled,
  ThemeLoader,
} from "../../../../../components/styled/Elements";
import { useEffect, useState } from "react";
import CabinetsApi from "../../../../../services/api/cabinetsApi";
import { ErrorMessage, Field, useFormikContext } from "formik";
import styled from "styled-components";
import { ValidatedInputWrapper } from "../../../../../components/common/inputFields/ValidatedInput";
import { FormGroup } from "react-bootstrap";
import FileAttachment from "./FileAttachment";
import { FormRadioWrapper } from "./styled";

const TypeSelection = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { setFieldValue, values } = useFormikContext();

  const [isLoading, setIsLoading] = useState(false);
  const [typeOptions, setTypeOptions] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const getArchiveTypes = async () => {
    try {
      setIsLoading(true);
      const { data, code } = await CabinetsApi.getArchiveTypes();
      if (code === 200 && data) {
        setTypeOptions(
          data?.map((option) => ({
            ...option,
            name: language === "en" ? option?.name_en : option?.name_ar,
          })),
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getArchiveTypes();
  }, []);

  if (isLoading) {
    return (
      <Box className="d-flex align-items-center justify-content-center w-100">
        <ThemeLoader />
      </Box>
    );
  }

  return (
    <>
      <FormElementWrapper className="combined pt-3">
        <Box className="formEleContainer">
          <LabelStyled className="labelForm">{t("type")}*</LabelStyled>
          <Box className="radiosContainer">
            {typeOptions?.map((x, i) => (
              <FormRadioWrapper
                key={x.id}
                sublabel={""}
                className="archiveRadios"
              >
                <Field
                  type="radio"
                  name="archive_type_id"
                  className="radio-input"
                  value={x.id}
                  checked={values.archive_type_id === x.id}
                  onChange={(e) => {
                    setFieldValue("archive_type_id", Number(e.target.value));
                  }}
                />
                <Box>
                  <SpanStyled
                    as="label"
                    size="16px"
                    color="var(--text)"
                    checked={Number(values.archive_type_id) === x.id}
                    className="radio-label"
                  >
                    {t(x.name)}
                  </SpanStyled>
                </Box>
              </FormRadioWrapper>
            ))}
          </Box>
        </Box>
      </FormElementWrapper>
      {values.archive_type_id === 5 && (
        <ValidatedInputWrapper className="combined">
          <FormGroup className="formEleContainer">
            <LabelStyled className="border-0" size="15px" color="var(--text)">
              {t("OtherType")}
              <span className="staric">*</span>
            </LabelStyled>

            <Box className="w-100">
              {/* Input Field */}
              <Field
                name="other_type"
                type="text"
                placeholder={t("OtherType")}
                className="form-control"
              />
              {/* Error Message */}
              <ErrorMessage
                name="other_type"
                component="div"
                className="text-danger text-sm mb-0 mt-1"
              />
            </Box>
          </FormGroup>
        </ValidatedInputWrapper>
      )}
      <ValidatedInputWrapper className="combined">
        <FormGroup className="formEleContainer">
          <LabelStyled className="border-0" size="15px" color="var(--text)">
            {t("Description")}
            <span className="staric">*</span>
          </LabelStyled>

          <Box className="w-100">
            {/* Input Field */}
            <Field
              name="description"
              type="text"
              placeholder={t("Description")}
              className="form-control"
            />
            {/* Error Message */}
            <ErrorMessage
              name="description"
              component="div"
              className="text-danger text-sm mb-0 mt-1"
            />
          </Box>
        </FormGroup>
      </ValidatedInputWrapper>
      {values.archive_type_id === 1 && (
        <ValidatedInputWrapper className="combined">
          <FormGroup className="formEleContainer">
            <LabelStyled className="border-0" size="15px" color="var(--text)">
              {t("Nopages")}
              <span className="staric">*</span>
            </LabelStyled>

            <Box className="w-100">
              {/* Input Field */}
              <Field
                name="no_of_pages"
                type="number"
                placeholder={t("Nopages")}
                className="form-control"
              />
              {/* Error Message */}
              <ErrorMessage
                name="no_of_pages"
                component="div"
                className="text-danger text-sm mb-0 mt-1"
              />
            </Box>
          </FormGroup>
        </ValidatedInputWrapper>
      )}
      {(values.archive_type_id === 2 || values.archive_type_id === 3) && (
        <ValidatedInputWrapper className="combined">
          <FormGroup className="formEleContainer">
            <LabelStyled className="border-0" size="15px" color="var(--text)">
              {t("Duration")}
              <span className="staric">*</span>
            </LabelStyled>

            <Box className="w-100">
              {/* Input Field */}
              <Field
                name="duration"
                type="text"
                placeholder={t("Duration")}
                className="form-control"
              />
              {/* Error Message */}
              <ErrorMessage
                name="duration"
                component="div"
                className="text-danger text-sm mb-0 mt-1"
              />
            </Box>
          </FormGroup>
        </ValidatedInputWrapper>
      )}

      <FormElementWrapper className="combined pt-3">
        <Box className="formEleContainer">
          <LabelStyled className="labelForm">{t("Attachment")}*</LabelStyled>
          {[1, 2, 3, 4, 5].includes(values.archive_type_id) && (
            <FileAttachment />
          )}
        </Box>
      </FormElementWrapper>
    </>
  );
};

export default TypeSelection;
